import React from 'react'
import Button from './Button'
import { ContactUs } from './styles'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <ContactUs data-type='main'>
      <div data-section='contact-us' data-type='section'>
        <h4 className='defaultTypographyH4' data-section='contact-us-text'>
          Work with an expert curator for all your art needs
        </h4>
        <Button />
      </div>
    </ContactUs>
  )
}

export default Component
